import { formatTimestampToDate } from './formatTimestampToDate'

export function checkAndMountTimestamp(tsBegin: string, tsEnd: string): string {
    let span = 'last 24 hours'
    if (tsBegin) {
        const ts1 = `${tsBegin ?? 0}`
        const ts2 = `${tsEnd ?? 0}`

        span =
            ts1 === '0' && ts1.length === 1 && ts2 === '0' && ts2.length === 1
                ? 'last 24 hours'
                : ts1 !== '0' && ts2 === '0'
                ? `${formatTimestampToDate(ts1)} to now`
                : `${formatTimestampToDate(ts1)} to ${formatTimestampToDate(ts2)}`
    }

    return span
}
